import { AsciiCommons, AsciiMythics } from "../data/ascii"
import { Color } from "../defines/colors"
import { ItemType } from "../defines/enums"
import { Symbol } from "../defines/symbols"
import { Collectible, CollectibleSet, RenderConfig } from "../defines/types"
import { Player } from "../player/player"
import { generateRandomNumber } from "./rng"

export function makeCollectible(type: ItemType, name: string): Collectible {
  const now = new Intl.DateTimeFormat("en-US", {
    dateStyle: "long",
    timeStyle: "long",
    timeZone: "America/New_York",
  }).format(new Date())

  return {
    type: type,
    name: name,
    found: now,
  }
}

export function getASCII(type: ItemType, key: string): string[] {
  let result: string[] = []

  let set = type == ItemType.COLLECTIBLE_COMMON ? AsciiCommons : AsciiMythics
  if (typeof set[key] !== undefined) {
    result = set[key]
  }

  return result
}

export function getCollectibleRender(type: ItemType): RenderConfig | undefined {
  if (type == ItemType.COLLECTIBLE_COMMON) {
    return {
      symbol: [Symbol.COLLECTIBLE_COMMON],
      light: Color.COLLECTIBLE_COMMON,
      dark: Color.COLLECTIBLE_COMMON_DARK,
    }
  } else if (type == ItemType.COLLECTIBLE_MYTHIC) {
    return {
      symbol: [Symbol.COLLECTIBLE_MYTHIC],
      light: Color.COLLECTIBLE_MYTHIC,
      dark: Color.COLLECTIBLE_MYTHIC_DARK,
    }
  }
  return undefined
}

export function getRandomCommonCollectible(
  player: Player
): Collectible | undefined {
  const have = player.commonCollectibles

  let possibles: string[] = []
  Object.keys(AsciiCommons).forEach((c) => {
    const found = have.find((cc) => {
      return c == cc.name
    })
    if (found === undefined) {
      possibles.push(c)
    }
  })

  if (possibles.length > 0) {
    const idx = generateRandomNumber(0, possibles.length - 1)
    return makeCollectible(ItemType.COLLECTIBLE_COMMON, possibles[idx])
  }

  return undefined
}

export function getRandomMythicCollectible(
  player: Player
): Collectible | undefined {
  const have = player.mythicCollectibles

  let possibles: string[] = []
  Object.keys(AsciiMythics).forEach((c) => {
    const found = have.find((cc) => {
      return c == cc.name
    })
    if (found === undefined) {
      possibles.push(c)
    }
  })

  if (possibles.length > 0) {
    const idx = generateRandomNumber(0, possibles.length - 1)
    return makeCollectible(ItemType.COLLECTIBLE_MYTHIC, possibles[idx])
  }

  return undefined
}

export function initCollectibleSet(): CollectibleSet {
  return {
    jan: undefined,
    feb: undefined,
    mar: undefined,
    apr: undefined,
    may: undefined,
    jun: undefined,
    jul: undefined,
    aug: undefined,
    sep: undefined,
    oct: undefined,
    nov: undefined,
    dec: undefined,
  }
}

export function isCollectible(type: ItemType): boolean {
  return isCommonCollectible(type) || isMythicCollectible(type)
}

export function isCommonCollectible(type: ItemType): boolean {
  return type == ItemType.COLLECTIBLE_COMMON
}

export function isMythicCollectible(type: ItemType): boolean {
  return type == ItemType.COLLECTIBLE_MYTHIC
}
